/**
 * Shared TypeScript types for YouTubeMost
 */

export interface Video {
  id: string;
  title: string;
  channelTitle: string;
  channelId: string;
  thumbnail: string;
  viewCount: number;
  publishedAt: string;
  duration: string; // ISO 8601 duration format (e.g., "PT4M13S")
  durationSeconds?: number;
  deltaViews?: number;
  deltaPerHour?: number;
  isShort?: boolean;
}

// New D1-based API response
export interface VideosApiResponse {
  region: string;
  categoryId: string;
  time: string;
  shorts: boolean;
  cached: boolean;
  generatedAt: number;
  videos: VideoApiItem[];
}

export interface VideoApiItem {
  videoId: string;
  title: string;
  channelId: string;
  channelTitle: string;
  thumbnailUrl: string;
  durationSeconds: number;
  viewCount: number;
  likeCount: number | null;
  commentCount: number | null;
  deltaViews: number;
  deltaPerHour: number;
  isShort: boolean;
  lastSnapshotAt: number;
  publishedAt: number | null;
}

// Legacy API response (for backwards compatibility)
export interface ApiResponse {
  videos: Video[];
  cached: boolean;
  fetchedAt?: string;
}

export interface ApiError {
  error: string;
}

export interface Category {
  id: string;
  name: string;
}

// LTS: Simplified to just trending (time periods removed)
export const DEFAULT_PERIOD = 'trending';

// YouTube video categories (aligned with backend - only those we fetch)
export const CATEGORIES: Category[] = [
  { id: 'ALL', name: 'All Categories' },
  { id: '10', name: 'Music' },
  { id: '17', name: 'Sports' },
  { id: '20', name: 'Gaming' },
  { id: '24', name: 'Entertainment' },
  { id: '25', name: 'News & Politics' },
];

export interface Region {
  id: string;
  name: string;
  flag: string;
}

// Available regions for filtering (aligned with backend)
export const REGIONS: Region[] = [
  { id: 'ALL', name: 'Worldwide', flag: '🌍' },
  { id: 'US', name: 'United States', flag: '🇺🇸' },
  { id: 'GB', name: 'United Kingdom', flag: '🇬🇧' },
  { id: 'IN', name: 'India', flag: '🇮🇳' },
  { id: 'JP', name: 'Japan', flag: '🇯🇵' },
  { id: 'KR', name: 'South Korea', flag: '🇰🇷' },
  { id: 'BR', name: 'Brazil', flag: '🇧🇷' },
  { id: 'DE', name: 'Germany', flag: '🇩🇪' },
  { id: 'FR', name: 'France', flag: '🇫🇷' },
  { id: 'CA', name: 'Canada', flag: '🇨🇦' },
  { id: 'AU', name: 'Australia', flag: '🇦🇺' },
  { id: 'MX', name: 'Mexico', flag: '🇲🇽' },
  { id: 'RU', name: 'Russia', flag: '🇷🇺' },
];

